import { createRoot } from 'react-dom/client';
import App from './App';
import { loadSentry } from './sentry';

import './scss/fontello.scss';
import './scss/sitebase.scss';
import './index.css';

// Required for Vite hot reload - I cannot explain why it is needed!
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const R = () => {};

if (import.meta.env.VITE_APP_SENTRY_DSN) {
  loadSentry();
}

// prevent warning msg on hot reload
const rootElement = document.getElementById('root');
if (!rootElement.__reactRoot) {
  rootElement.__reactRoot = createRoot(rootElement);
}
rootElement.__reactRoot.render(<App />);

// suppress react warnings
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && args[0]?.includes?.('will be removed')) {
    return;
  }
  originalConsoleError(...args);
};
